import { useEffect } from 'react';

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  phone: string;
}

export default function ContactModal({ isOpen, onClose, phone }: ContactModalProps) {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleEscape);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const digits = phone.replace(/\D/g, '');
  const whatsappUrl = `https://wa.me/521${digits}?text=${encodeURIComponent('Hola, quiero información para ser distribuidor.')}`;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-fade-in" style={{ animationDuration: '250ms' }}>
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose}></div>

      <div
        className="relative w-full max-w-sm rounded-3xl p-8 text-center animate-scale-in"
        style={{ background: 'oklch(var(--background-50))', animationDuration: '300ms' }}
      >
        <button
          onClick={onClose}
          className="absolute top-5 right-5 w-8 h-8 rounded-full flex items-center justify-center text-foreground-400 hover:text-foreground-950 hover:bg-foreground-100 transition-all duration-200 cursor-pointer"
          aria-label="Cerrar"
        >
          <i className="ri-close-line text-xl"></i>
        </button>

        <div className="w-16 h-16 mx-auto mb-5 rounded-2xl flex items-center justify-center" style={{ background: 'oklch(var(--accent-500) / 0.10)' }}>
          <i className="ri-whatsapp-line text-3xl text-accent-600"></i>
        </div>

        <h3 className="text-xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
          Contáctanos
        </h3>
        <p className="text-foreground-500 text-sm mb-6">
          Escríbenos por WhatsApp y con gusto te guiamos para empezar como distribuidor.
        </p>

        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-white text-base font-semibold rounded-full hover:bg-accent-600 transition-all duration-300 hover:scale-[1.04] active:scale-[0.97] cursor-pointer whitespace-nowrap">
          <i className="ri-whatsapp-line"></i>
          {phone}
        </a>
      </div>
    </div>
  );
}